<template>
  <ul class="modal-menu">
    <li v-for="(item, index) in items" :key="item.id" :class="{ selected: item == selected }">
      <slot v-bind="item" :index="index"></slot>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: []
    },
    selected: {
      default: null
    }
  }
}
</script>

<style>
  .modal-menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .modal-menu > li {
    font-size: 1.25em;
    font-weight: bold;
    padding: 0.75em 0;
    transition: font-size 300ms;
  }

  .modal-menu > li > button {
    padding: 0;
    margin: 0;
    background-color: transparent;
    color: inherit;
    border: 0;
    opacity: 0.85;
  }

  .modal-menu > li.selected {
    font-size: 1.375em;
  }

  .modal-menu > li > button:focus,
  .modal-menu > li > button:hover,
  .modal-menu > li.selected button {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalMenu.vue